import React, { useCallback } from "react";

import { Sidebar } from "../../../packages/excalidraw/index";
import { useExcalidrawSetAppState } from "../../../packages/excalidraw/components/App";
import { AgentsPanel } from "./AgentsPanel";
import { plugIcon } from "./plugIcon";

/**
 * The Agents body as a right-side drawer inside the editor, on Excalidraw's
 * host-sidebar mechanism: `openSidebar` in app state opens it, and the
 * sidebar itself handles the close button, Escape and outside clicks. Every
 * in-app entry point (main menu, welcome shortcut, toolbar flyout) opens this;
 * `/agents` stays as the deep link.
 */
export const AGENTS_SIDEBAR_NAME = "agents";

/** Opens the drawer; usable anywhere inside `<Excalidraw>`. */
export const useOpenAgentsDrawer = () => {
  const setAppState = useExcalidrawSetAppState();
  return useCallback(
    () => setAppState({ openSidebar: { name: AGENTS_SIDEBAR_NAME } }),
    [setAppState],
  );
};

export const AgentsSidebar: React.FC = () => (
  <Sidebar name={AGENTS_SIDEBAR_NAME} className="agents-sidebar">
    <Sidebar.Header>
      <span className="agents__mark" aria-hidden="true">
        {plugIcon}
      </span>
      <h2 className="agents-sidebar__title">Agents</h2>
    </Sidebar.Header>
    <div className="agents-sidebar__body">
      <AgentsPanel context="drawer" />
    </div>
  </Sidebar>
);
